<script lang="ts">
	/**
	 * The small "opens elsewhere" glyph — an arrow leaving a box.
	 *
	 * Hand-drawn as an inline SVG rather than pulled from Font Awesome or
	 * flowbite-svelte-icons because it sits *inside* running text: it needs a
	 * hairline stroke (`stroke-width: 1`) and `currentColor` so it inherits the
	 * link's colour and hover state instead of fighting it.
	 *
	 * Size it from the caller — the SVG has no intrinsic dimensions, so it
	 * collapses to nothing unless the class sets `w-*`/`h-*`.
	 */

	/** Sizing/colour classes. Typically `h-3 w-3 inline align-baseline`. */
	let iconClass: string = '';
	export { iconClass as class };
</script>

<svg class={iconClass} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
	<path
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-width="1"
		d="M15 11v4.833A1.166 1.166 0 0 1 13.833 17H2.167A1.167 1.167 0 0 1 1 15.833V4.167A1.166 1.166 0 0 1 2.167 3h4.618m4.447-2H17v5.768M9.111 8.889l7.778-7.778" />
</svg>
